import { render, staticRenderFns } from "./AdminNewTender.vue?vue&type=template&id=1aa2aba4&"
import script from "./AdminNewTender.vue?vue&type=script&lang=js&"
export * from "./AdminNewTender.vue?vue&type=script&lang=js&"
import style0 from "./AdminNewTender.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports